import actions from './action'

const initialState = {
  data: [],
  dayOffdata: [],
  totalCount: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
  leaveRecord: [],
  empLeaveReport: [],
  loading: false,
  leaveHour: null,
}

const fetchEmpLeaveData = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EMP_LEAVE_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case actions.FETCH_EMP_DAY_OFF_DATA:
      return {
        ...state,
        dayOffdata: action.payload,
      }
    case actions.FETCH_EMP_LEAVE_REQUEST_DATA:
      return {
        ...state,
        leaveRequestData: action.payload,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.GET_SINGLE_LEAVE_REQUEST_RECORD:
      return {
        ...state,
        leaveRecord: action.payload,
      }
    case actions.HANDLE_EMP_LEAVE_REPORT:
      return {
        ...state,
        empLeaveReport: action.payload?.leaveRecord,
        totalCount: action.payload?.totalCount,
      }
    case actions.HANDLE_PAID_LEAVE_HOUR:
      return {
        ...state,
        leaveHour: action.payload.paidLeavehour,
      }
    default:
      return state
  }
}

export default fetchEmpLeaveData
